/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { assetsGetCategories } from "../../funcs/assetsGetCategories.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$assetsGetCategories: ToolDefinition = {
  name: "assets-get-categories",
  description: `List available asset categories (e.g. Futures)

Returns a list of all available asset categories, such as
        futures. Prices, forecasts, and indicators are available for each.`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await assetsGetCategories(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
